export default "__VITE_ASSET__BLp_az12__"